import {useContext, useState} from "react";
import "./UpdateTransactionState.css";
import {AccountContext} from "../AccountContext";

const UpdateTransactionState = (props) => {
  const {accountId, transactionService, setError} = useContext(AccountContext);
  const {transactionId, transactionStateUpdated} = props;
  const [updatingTransactionState, setUpdatingTransactionState] = useState(false as boolean);
  const [transactionState, setTransactionState] = useState('NoStatus');

  function timeout() {
    return new Promise( res => setTimeout(res, 500) );
  }

  const onUpdateTransactionState = async () => {
    try {
      setUpdatingTransactionState(true);
      await transactionService.changeStatus(accountId, transactionId, transactionState)
      await timeout();
      transactionStateUpdated();
      setUpdatingTransactionState(false);
    } catch (error) {
      setUpdatingTransactionState(false);
      setError({source: 'Updating Transaction State', ...error});
    }
  };

  return (
      <div className="field fill">
        <div className="ui labeled input">
          <select onChange={e => setTransactionState(e.target.value)}>
              <option value="NoStatus">None</option>
              <option value="ReportedFraud">Reported</option>
              <option value="SuspectedFraud">Suspected</option>
              <option value="ConfirmedFraud">Confirmed</option>
              <option value="ConfirmedFraudChargeOff">Confirmed: Charge Off</option>
              <option value="ConfirmedFraudChargeback">Confirmed: Chargeback</option>
              <option value="ConfirmedFraudPartialChargeback">Confirmed: Partial Chargeback</option>
              <option value="DisputeChargeback">Dispute Chargeback</option>
          </select>
          <button className={`ui right floated fluid button ${updatingTransactionState ? 'loading': ''}`} onClick={onUpdateTransactionState}>Update</button>
        </div>
      </div>);
}

export default UpdateTransactionState;